<template>
  <BaseForm
    :title="formTitle"
    :formData="haulerData"
    :fields="fields"
    :submitUrl="submitUrl"
    :method="method"
    @form-success="handleSuccess"
    @form-error="handleError"
  />
</template>

<script>
import BaseForm from './BaseForm.vue';
import axios from 'axios';

export default {
  components: {
    BaseForm
  },
  props: {
    haulerId: {
      type: Number,
      default: null
    }
  },
  data() {
    return {
      haulerData: {
        name: '',
        address_line1: '',
        address_line2: '',
        city: '',
        state: '',
        zip_code: '',
        office_phone: '',
        contact_person: '',
        cell_phone: '',
        fax: '',
        email: ''
      },
      fields: [
        { model: 'name', label: 'Name', required: true, type: 'text' },
        { model: 'address_line1', label: 'Address Line 1', type: 'text' },
        { model: 'address_line2', label: 'Address Line 2', type: 'text' },
        { model: 'city', label: 'City', type: 'text' },
        { model: 'state', label: 'State', type: 'text' },
        { model: 'zip_code', label: 'Zip Code', type: 'text' },
        { model: 'office_phone', label: 'Office Phone', type: 'text' },
        { model: 'contact_person', label: 'Contact Person', type: 'text' },
        { model: 'cell_phone', label: 'Cell Phone', type: 'text' },
        { model: 'fax', label: 'Fax', type: 'text' },
        { model: 'email', label: 'Email', type: 'email' }
      ]
    };
  },
  computed: {
    formTitle() {
      return this.haulerId ? `Edit Hauler` : 'Add Hauler';
    },
    submitUrl() {
      return this.haulerId ? `/api/v1/hauler/haulers/${this.haulerId}/` : '/api/v1/hauler/haulers/';
    },
    method() {
      return this.haulerId ? 'put' : 'post';
    }
  },
  mounted() {
    if (this.haulerId) {
      this.loadHaulerData();
    }
  },
  methods: {
    loadHaulerData() {
      axios.get(`/api/v1/hauler/haulers/${this.haulerId}/`).then(response => {
        this.haulerData = response.data;
      }).catch(console.error);
    },
    handleSuccess() {
      this.$q.notify({
        color: 'green',
        position: 'top',
        message: 'Hauler information saved successfully!',
        icon: 'check_circle',
        timeout: 3000
      });
    },
    handleError(error) {
      console.error(error);
      this.$q.notify({
        color: 'red',
        position: 'top',
        message: 'There was a problem saving the hauler information!',
        icon: 'check_circle',
        timeout: 3000
      });
    }
  }
};
</script>
